<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader" />

    <div class="row">
      <div class="col-12">
        <legend class="text-primary mb-4">
          <h5>Documento de queja del OEC</h5>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">DOCUMENTO</th>

              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="inputs.complaint_document_oec">
              <td class="align-middle">Oficio cargado por el OEC</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'complaint_document_oec')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12" v-if="inputs.attach_complaint_document_oec && inputs.attach_complaint_document_oec.length > 0">
        <legend class="text-primary mb-4 mt-3">
          <h5>Documentos adicionales del OEC</h5>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(value, key) in inputs.attach_complaint_document_oec"
              :key="key"
            >
              <td class="align-middle">
                <small class="text-primary">{{
                  value.path.split("/")[value.path.split("/").length - 1]
                }}</small>
              </td>
              <td class="align-middle text-center">
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(inputs.attach_complaint_document_oec, key)
                    "
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <legend class="text-primary mb-4">
          <h5>Documentación de queja</h5>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">DOCUMENTO</th>

              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            
            <tr v-if="inputs.dgc_complaint_document">
              <td class="align-middle">Documento emitido por la DGC</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'dgc_complaint_document')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="inputs.analysis_complaint_document">
              <td class="align-middle">Informe de análisis de la queja</td>

              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'analysis_complaint_document')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import { axiosGet } from "../../../../../../../../resources/js/app/helpers/AxiosHelper";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  name: "AnnexedReviewComplaintDocument",
  mixins: [FormMixin],
  props: {
    id: String,
    dgc_complaint_document: Object,
    area_director_complaint_document: Object,
    analysis_complaint_document: Object,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let url = `complaints/reviewComplaintDocuments/${this.$store.state.evaluatorReview.evalTestId}`;
      axiosGet(url).then((response) => {
        this.inputs = response.data;
      });
    },
    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
  },
};
</script>
